import React, { useState } from 'react';
import ResponseManage from "./lib/ResponseManage/ResponseManage"
import MessageActions from './lib/MessageManage/MessageActions/MessageActions';
import { DnD_element_type } from './lib/common/ConstantValues';
import { onDropComponent } from './lib/MessageManage/DropComponentCommonFunctions'

const Implementor = (props) => {
  
  /**
   * Response state
   */
  const [editCurrentResponse, setEditCurrentResponse] = useState(null)
  
  /**
   * Message state
   */
  const [currentEditMessage, setEditCurrentMessage] = useState(null)

  /**
   * SlidePage state 
   */
  const [editCurrentSlidePage, setEditCurrentSlidePage] = useState(null)
  const [editingMsgIndex, setEditingMsgIndex] = useState(null)
  const [editingRowIndex, setEditingRowIndex] = useState(null)
  const [editingSPIndex, setEditingSPIndex] = useState(null)
  /* actions */
  const setEditingIndexes = (e) => {
    if (!e) {
      setEditingMsgIndex(null)
      setEditingRowIndex(null)
      setEditingSPIndex(null)
    } else {
      const {message_index, row_index, slide_page_index} = e
      if (message_index || message_index === 0) {
        setEditingMsgIndex(message_index)
      } else { setEditingMsgIndex(null) }
      if (row_index || row_index === 0) {
        setEditingRowIndex(row_index)
      } else { setEditingRowIndex(null) }
      if (slide_page_index || slide_page_index === 0) {
        setEditingSPIndex(slide_page_index)
      } else { setEditingSPIndex(null) }
    }
  }

  /**
   * DnD state
   */
  const [isDragging, setIsDragging] = useState(false)
  
  /**
   * Arguments for MessageAction function wrappers
   */
  const editTargetState = {
    currentEditMessage: currentEditMessage,
    currentEditSlidePage: editCurrentSlidePage,
  }
  /**
   * MessageAction function wrappers
   */
  const addComponent = (arg) => {
    const { type } = arg
    const { editState, result } = MessageActions.ADD_COMPONENT(editTargetState, arg, type)
    if (editState === 'SLIDE_PAGE') {
      setEditCurrentSlidePage(result)
    } else {
      setEditCurrentMessage(result)
    }
  }
  const deleteMessage = (indexToDel) => {
    const result = MessageActions.DELETE_MESSAGE(currentEditMessage, indexToDel)
    setEditCurrentMessage(result) 
  }
  const updateComponentIndexPos = (arg) => {
    const { editState, result } = MessageActions.UPDATE_COMPONENT_INDEX_POS(editTargetState, arg)
    if (editState === 'SLIDE_PAGE') {
      setEditCurrentSlidePage(result)
    } else {
      setEditCurrentMessage(result)
    }
  }
  const updateDepthCompIndexPos = (arg) => {
    // This editTargetState but, returns only messagesData(not slide page)
    setEditCurrentMessage(MessageActions.UPDATE_DEPTH_COMPONENT_INDEX_POS(editTargetState, arg))
  }
  const addMessage = (arg) => {
    setEditCurrentMessage(MessageActions.ADD_MESSAGE(currentEditMessage, arg))
  }
  const updateMessageIndex = (arg) => {
    setEditCurrentMessage(MessageActions.UPDATE_MESSAGE_INDEX(currentEditMessage, arg))
  }
  // const setCurrentEditSlidePage = (messages, indexes) => {

  // }
  const updateSlidePageToMessage = (arg) => {
    // This editTargetState but, returns only messagesData(not slide page)
    setEditCurrentMessage(MessageActions.UPDATE_SLIDE_PAGE_TO_MESSAGE(editTargetState, arg)) 
  }
  const deleteComponent = (arg) => {
    console.log('arg :', arg);
    const { editState, result } =  MessageActions.DELETE_COMPONENT(editTargetState, arg)
    console.log('result :', result);
    if (editState === 'SLIDE_PAGE') {
      setEditCurrentSlidePage(result)
    } else {
      setEditCurrentMessage(result)
    }
  }
  // const setIsDragging = () => {

  // }
  const updateRow = (arg) => {
    const { row } = arg
    const { editState, result } = MessageActions.UPDATE_ROW(editTargetState, arg, row)
    if (editState === 'SLIDE_PAGE') {
      setEditCurrentSlidePage(result)
    } else {
      setEditCurrentMessage(result)
    }
  }
  const copyComponent = (arg) => {
    setEditCurrentMessage(MessageActions.COPY_COMPONENT(currentEditMessage, arg)) 
  }
  // const setIndex = (messages, indexes) => {
  //   return MessageActions.UPDATE_MESSAGE_INDEX(messages, indexes)
  // }
  const updateComponent = (arg) => {
    const { updateInfo, indexInfo } = arg
    const { editState, result } = MessageActions.UPDATE_COMPONENT(editTargetState, indexInfo, updateInfo)
    if (editState === 'SLIDE_PAGE') {
      setEditCurrentSlidePage(result)
    } else {
      setEditCurrentMessage(result)
    }
  }

  const deleteDepthComponent = (arg) => {
    setEditCurrentMessage(MessageActions.DELETE_DEPTH_COMPONENT(currentEditMessage, arg))
  }

  const _setIsDragging = ({dragging}) => {
    console.log('dragging :', dragging);
    setIsDragging(dragging)
  }

  /**
   * Wrapped messageActions Object
   */
  const _messageActions = {
    addComponent: addComponent,
    deleteMessage: deleteMessage,
    updateComponentIndexPos: updateComponentIndexPos,
    updateDepthCompIndexPos: updateDepthCompIndexPos,
    addMessage: addMessage,
    updateMessageIndex: updateMessageIndex,
    updateSlidePageToMessage: updateSlidePageToMessage, 
    deleteComponent: deleteComponent,
    updateRow: updateRow,
    copyComponent: copyComponent,
    updateComponent: updateComponent,
    setIndexForSlidePage: setEditingIndexes, // setIndex
    setIsDragging: _setIsDragging,
    setCurrentEditSlidePage: setEditCurrentSlidePage,
  }

  /**
   * ResponseManage dropped delete area trigger
   */
  const onDropDeleteArea = (e) => {
    // this.props.setMsgChanges(true)
    if (isDragging) {
      setIsDragging(false)
    }
    const { rowIndexDetail, type, prefix_type } = e
    e = {...e,
      row_index_detail: rowIndexDetail,
      slide_page_index: editingSPIndex,
    }

    // Logic for depth components
    if (type === DnD_element_type.COMPONENT.NORMAL.GROUP && prefix_type === "NORMAL") {
      onDropComponent(deleteDepthComponent, e)
      return
    }

    onDropComponent(deleteComponent, e, null, null, null)
  }

  /**
   * ResponseManage complete editing
   */
  const onComplete = (e) => {
    console.log('currentEditMessage :', currentEditMessage);
  }

  return (
    <ResponseManage
      onMsgChanges = {(e) => {
        console.log('Message on change / e :>> ', e);
      }}
      // currentEditMessage = {currentEditMessage}
      currentEditSlidePage = {editCurrentSlidePage}

      isDragging = {isDragging}

      // onComplete = {onComplete}

      conditionActions = {{
        addCondition: () => {
          
        },
        updateCondition: () => {

        },
        deleteCondition: () => {

        }
      }}

      /**
       * UI
       */
      onDropDeleteArea = {onDropDeleteArea}
      noHeader = {true}
      showTabs={{
        GLOBAL_ENTITY: true,
      }}

      /**
       * Editing indexes
       */
      editing_message_index = {editingMsgIndex}
      editing_row_index = {editingRowIndex}
      editing_slide_page_index = {editingSPIndex}

      // messageActions = {_messageActions}

      hideUIs={{
        RemoveResponseBtn: true,
        Settings: true,
      }}
    />
  )
}

/**
 * Condition list
 */
const addCondition = () => {
  
}
const updateCondition = () => {
  
}
const deleteCondition = () => {
  
}

export default Implementor